// auth
export const LOGOUT = 'LOGOUT';
export const LOGIN_REQUESTED = 'LOGIN_REQUESTED';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const UPDATE_USER = 'UPDATE_USER';
// nav
export const PATH_CHANGED = 'PATH_CHANGED';
// clusters
export const CLUSTERS_GET_CLUSTERS_REQUESTED =
  'clusters/CLUSTERS_GET_CLUSTERS_REQUESTED';
export const CLUSTERS_GET_CLUSTERS_UPDATED =
  'clusters/CLUSTERS_GET_CLUSTERS_UPDATED';
export const CLUSTERS_GET_MERCHANT_BY_MERCHANT_ID_REQUESTED =
  'clusters/CLUSTERS_GET_MERCHANT_BY_MERCHANT_ID_REQUESTED';
export const CLUSTERS_GET_MERCHANT_BY_MERCHANT_ID_UPDATED =
  'clusters/CLUSTERS_GET_MERCHANT_BY_MERCHANT_ID_UPDATED';
export const CLUSTERS_GET_OFFER_BY_OFFER_ID_REQUESTED =
  'clusters/CLUSTERS_GET_OFFER_BY_OFFER_ID_REQUESTED';
export const CLUSTERS_GET_OFFER_BY_OFFER_ID_UPDATED =
  'clusters/CLUSTERS_GET_OFFER_BY_OFFER_ID_UPDATED';
export const CLUSTERS_GET_MERCHANTS_REQUESTED =
  'clusters/CLUSTERS_GET_MERCHANTS_REQUESTED';
export const CLUSTERS_GET_MERCHANTS_UPDATED =
  'clusters/CLUSTERS_GET_MERCHANTS_UPDATED';
export const CLUSTERS_GET_MERCHANTS_INVALIDATE =
  'clusters/CLUSTERS_GET_MERCHANTS_INVALIDATE';
export const CLUSTERS_SEND_OFFER_CODE_REQUESTED =
  'clusters/CLUSTERS_SEND_OFFER_CODE_REQUESTED';
export const CLUSTERS_SEND_OFFER_CODE_UPDATED =
  'clusters/CLUSTERS_SEND_OFFER_CODE_UPDATED';
export const CLUSTERS_SEND_OFFER_CODE_RESET =
  'clusters/CLUSTERS_SEND_OFFER_CODE_RESET';
// LANDING PAGE
export const USER_LANDED = 'landing/USER_LANDED';
export const LANDING_GET_CLUSTER_BY_CLUSTER_ID_REQUESTED =
  'landing/LANDING_GET_CLUSTER_BY_CLUSTER_ID_REQUESTED';
export const LANDING_GET_CLUSTER_BY_CLUSTER_ID_UPDATED =
  'landing/LANDING_GET_CLUSTER_BY_CLUSTER_ID_UPDATED';
export const MARK_COOKIE_BANNER_SEEN = 'app/MARK_COOKIE_BANNER_SEEN';
// SEASON CAMPAIGN
export const SEASON_CAMPAIGN_GET_CAMPAIGN_BY_CAMPAIGN_ID_REQUESTED =
  'seasonCampaign/SEASON_CAMPAIGN_GET_CAMPAIGN_BY_CAMPAIGN_ID_REQUESTED';
export const SEASON_CAMPAIGN_GET_CAMPAIGN_BY_CAMPAIGN_ID_UPDATED =
  'seasonCampaign/SEASON_CAMPAIGN_GET_CAMPAIGN_BY_CAMPAIGN_ID_UPDATED';
// DEEP_LINK
export const SAVE_DEEPLINK = 'deeplink/SAVE_DEEPLINK';
export const CLEAR_DEEPLINK = 'deeplink/CLEAR_DEEPLINK';
// REDEEMED OFFERS
export const CLUSTERS_GET_REDEEMED_OFFERS_REQUESTED =
  'CLUSTERS_GET_REDEEMED_OFFERS_REQUEST';
export const CLUSTERS_GET_REDEEMED_OFFERS_UPDATED =
  'CLUSTERS_GET_REDEEMED_OFFERS_UPDATED';
